import _ from 'lodash'
import PATH from 'quick-quote/constants/path'

import RiderGroup from 'quick-quote/product-common/coverage-plan/components/rider/rider-group'
import TotalPremiumInput from 'quick-quote/product-common/coverage-plan/components/basic-plan/total-premium-input'
import { Redirect } from 'react-router-dom'
import { InsuredInformationBreadcrumb } from 'quick-quote/components'

import BasicPlan from 'quick-quote/product-common/coverage-plan/components/basic-plan/basic-plan'
import ModelFactorSelection from 'quick-quote/product-common/coverage-plan/components/basic-plan/model-factor-selection'
import LifeReadySIOProductSelection from './life-ready-sio-product-selection'
import IShieldSIOProductSelection from './ishield-sio-product-selection'

const CoveragePlan = ({
  toggleRider,
  riderCodes,
  canProceedToCoveragePlan,
  displayProduct,
  editRiderSumAssured,
  editRiderSelectedPlan,
}) => {
  if (!canProceedToCoveragePlan) {
    return <Redirect to={PATH.PRODUCT_SELECTION} push />
  }
  let displayProductSelections = function(displayProduct) {
    let displayProductCode = _.get(displayProduct, 'code')
    switch (displayProductCode) {
      case 'SIO-W99FU06':
      case 'SIO-W99FU12':
      case 'SIO-W99FU18':
      case 'SIO-W99FH18':
      case 'SIO-W99FU99':
      case 'SIO-W99FH99':
        return <LifeReadySIOProductSelection />
      case 'SIO-WLCI05':
      case 'SIO-WLCI10':
      case 'SIO-WLCI15':
      case 'SIO-WLCI20':
        return <IShieldSIOProductSelection />
      default:
        return null
    }
  }

  return (
    <div>
      <InsuredInformationBreadcrumb />
      <div id="coverage-plan">
        <div className="content">
          <div id="basic-plan">
            <div className="content">
              <ModelFactorSelection />
              {displayProductSelections(displayProduct)}
              <BasicPlan />
            </div>
          </div>
          <div id="total-premium">
            <TotalPremiumInput />
          </div>
          <RiderGroup
            riderCodes={riderCodes}
            toggleRider={toggleRider}
            editRiderSumAssured={editRiderSumAssured}
            editRiderSelectedPlan={editRiderSelectedPlan}
          />
        </div>
      </div>
    </div>
  )
}

export default CoveragePlan
